/**
 * Burned area (ha) and fire counts per region/year.
 *
 * Generated by scripts/stats/generate-wildfire-stats.js from the tiler's plan CSV, whose
 * areas come from the NBAC source vectors — more accurate than counting
 * pixels in the rendered tiles, which are quantised to the zoom-14 grid.
 *
 *   { "kenora": { "2021": { "areaHa": 109281, "fires": 7 }, ... } }
 *
 * Same loader shape as clearcutAreaStats.js and wildfireYears.js.
 */

let _statsPromise = null;

function loadWildfireStats() {
  if (!_statsPromise) {
    // Served from the app's own origin (public/data), not the tile CDN.
    const base = process.env.PUBLIC_URL || '';
    _statsPromise = fetch(`${base}/data/wildfire_stats.json`)
      .then((r) => {
        if (!r.ok) throw new Error(`wildfire_stats.json: HTTP ${r.status}`);
        return r.json();
      })
      .catch((err) => {
        console.error('[WildfireStats]', err);
        _statsPromise = null;
        throw err;
      });
  }
  return _statsPromise;
}

/**
 * Burned area and fire count per year, summed across the given regions.
 * Every year in `years` gets an entry so the timeline stays continuous —
 * a year with no fire reads as a real zero, not a gap.
 *
 * @param {string[]} regions - FMU ids
 * @param {number[]} years   - years to report on
 * @returns {Promise<Array<{year:number, areaHa:number, fires:number}>>}
 */
export async function getBurnedAreaPerYear(regions, years) {
  if (!Array.isArray(regions) || regions.length === 0) return [];

  const all = await loadWildfireStats();

  return years.map((year) => {
    let areaHa = 0;
    let fires = 0;

    for (const region of regions) {
      const entry = all[String(region || '').toLowerCase()]?.[String(year)];
      if (entry) {
        areaHa += entry.areaHa || 0;
        fires += entry.fires || 0;
      }
    }

    return { year, areaHa: Math.round(areaHa * 10) / 10, fires };
  });
}

export function clearWildfireStatsCache() {
  _statsPromise = null;
}
